import { render, staticRenderFns } from "./partyBuild.vue?vue&type=template&id=583fa800"
import script from "./partyBuild.vue?vue&type=script&lang=js"
export * from "./partyBuild.vue?vue&type=script&lang=js"
import style0 from "./partyBuild.vue?vue&type=style&index=0&id=583fa800&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports